import React from 'react'

interface Props { code?: number }

export const UnexpectedError: React.FC<Props> = ({ code }) => (
  <div className="vh-100 d-flex align-items-center justify-content-center text-danger">
    <i className="material-icons h3 mr-3">error</i>
    <div>
      <h4>發生異常錯誤!!</h4>
      <h6>錯誤代碼 {code}</h6>
    </div>
  </div>
)